<script lang="ts" setup>
import { defineComponent, onMounted, reactive } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";

//servicos
import * as service from "@/services/clientesContratosService";
import { fdata, fdataUS } from "@/utils/funcoes";

//componentes
import Paginador from "@/components/Paginador/Index.vue";
import ImgUsuario from "@/components/Imagens/ImgUsuario.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
import DropdownPlanos from "@/components/Dropdowns/DropdownPlanos.vue";

var controle = reactive({
  filtros: {
    statusId: null,
    tipoId: null,
    paginaAtual: 1,
    tamanhoPagina: 10
  } as unknown as service.Filtros,
  itens: [] as service.Contrato[],
  totalRegistros: 0,

  listaStatus: [
    { valor: null, descricao: "- Todos -" },
    { valor: true, descricao: "Ativos" },
    { valor: false, descricao: "Inativos" },
  ],
  itemExcluir: null as service.Contrato | null,
  janExcluir: false,
  status: "",
  erro: "",

  itemExtender: null as service.Contrato | null,
  janExtender: false,
  formExtender: {
    dataInicial: null as string | null,
    mesesExtender: 12,
  },
  statusExtender: "",
  erroExtender: "",

  ordenacao: {
    coluna: '',
    asc: true
  },
})

onMounted(async () => {
  pesquisar();
})

async function pesquisar() {

  service.obter(controle.filtros)
    .then(r => {
      controle.itens = r;
      controle.totalRegistros = 1000;
    })
    .catch(erro => {
      controle.erro = erro;
    })
}

function ordenarPor(coluna: string) {
  if (controle.ordenacao.coluna === coluna) {
    controle.ordenacao.asc = !controle.ordenacao.asc;
  } else {
    controle.ordenacao.coluna = coluna;
    controle.ordenacao.asc = true;
  }
  controle.itens.sort((a, b) => {
    let valA = (a as Record<string, any>)[coluna];
    let valB = (b as Record<string, any>)[coluna];
    if (typeof valA === 'string') valA = valA.toLowerCase();
    if (typeof valB === 'string') valB = valB.toLowerCase();
    if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
    if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
    return 0;
  });
}

function pergExcluir(item: service.Contrato) {
  controle.janExcluir = true;
  controle.itemExcluir = item;
}

function excluir() {
  if (controle.itemExcluir) {
    service.excluir(controle.itemExcluir.contratoId!)
      .then(() => {
        controle.janExcluir = false;
        pesquisar();
      })
      .catch(erro => {
        controle.erro = erro;
        controle.janExcluir = false;
      });
  }
}

function abrirExtender(item: service.Contrato) {
  controle.itemExtender = item;
  controle.formExtender = {
    dataInicial: fdataUS(item.dataFim) ?? fdataUS(new Date().toISOString()),
    mesesExtender: 12,
  };
  controle.erroExtender = "";
  controle.janExtender = true;
}

function confirmarExtender() {
  if (!controle.itemExtender) return;

  controle.statusExtender = "Extendendo contrato...";
  controle.erroExtender = "";

  service.extenderContrato({
    contratoId: controle.itemExtender.contratoId!,
    dataInicial: controle.formExtender.dataInicial,
    mesesExtender: controle.formExtender.mesesExtender,
  })
    .then(() => {
      controle.statusExtender = "";
      controle.janExtender = false;
      pesquisar();
    })
    .catch((erro) => {
      controle.erroExtender = `Erro ao extender contrato: ${erro.message || erro}`;
      controle.statusExtender = "";
    });
}
</script>

<template>
  <BreadCrumb PageTitle="Contratos" />

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-6 col-md-2">
          <label><i class="flaticon-search"></i> Pesquisar</label>
          <input type="text" class="form-control form-control-sm" placeholder="Nome" v-model="controle.filtros.nome"
            @input="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Contrato</label>
          <input type="text" class="form-control form-control-sm" placeholder="Nro Contrato."
            v-model="controle.filtros.contratoId" @input="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Vendedor</label>
          <DropdownVendedores v-model="controle.filtros.vendedorId" @change="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Plano</label>
          <DropdownPlanos v-model="controle.filtros.planoId" @change="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Status</label>
          <select class="form-select form-select-sm" v-model="controle.filtros.statusId" @change="pesquisar">
            <option :value="null">- Todos -</option>
            <option :value="1">Aguard. Assinatura</option>
            <option :value="2">Ativo</option>
          </select>
        </div>


        <!-- <div class="col-md-2">
          <RouterLink class="btn btn-primary btn-sm mt-4 float-end" :to="'/usuarios/cadastro'"><i
              class="flaticon-plus"></i> Adicionar</RouterLink>
        </div> -->
      </div>
      <div class="row mt-2">
        <div class="col-md-12 table-responsive">
          <table class="table  align-middle mb-0 table-hover">
            <thead>
              <tr>
                <th @click="ordenarPor('contratoId')" class="th-sortable">Id</th>
                <th @click="ordenarPor('nomeCompleto')" class="th-sortable">Cliente / Empresa</th>
                <th @click="ordenarPor('planoId')" class="th-sortable">Plano</th>
                <th @click="ordenarPor('vendedorId')" class="th-sortable">Vendedor</th>
                <th @click="ordenarPor('dataInicio')" class="th-sortable">Inicio</th>
                <th @click="ordenarPor('dataFim')" class="th-sortable">Fim</th>
                <th @click="ordenarPor('dataAssinatura')" class="th-sortable">Assinatura</th>
                <th @click="ordenarPor('statusId')" class="th-sortable">Status</th>

                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in controle.itens" :key="idx" class="align-middle">
                <td>{{ item.contratoId }}</td>
                <td class="nowrap-celular">
                  {{ item.cliente != null ? item.cliente.nome :
                    item.empresa != null ? item.empresa.nome : '' }}
                </td>
                <td class="nowrap-celular">{{ item.plano.nome }}</td>
                <td class="nowrap-celular">{{ item.vendedor?.nomeCompleto }}</td>

                <td>
                  {{ fdata(item.dataInicio) }}
                </td>
                <td>
                  {{ fdata(item.dataFim) }}
                </td>
                <td>
                  {{ fdata(item.dataAssinatura) }}
                </td>
                <td>
                  <span class="badge rounded-pill" :class="item.statusId === 2 ? 'badge-soft-success' : 'badge-soft-warning'">
                    {{ item.status.descricao }}
                  </span>
                </td>
                <td class="text-center text-nowrap">
                  <span>
                    <RouterLink :to="'/contratos/cadastro/' + item.contratoId">
                      <i class="flaticon-pen fs-5"></i>
                    </RouterLink>

                    <a class="ms-2" href="javascript:void(0);" title="Extender Contrato" @click="abrirExtender(item)">
                      <i class="flaticon-refresh fs-5 text-primary"></i>
                    </a>

                    <a class="ms-2" href="javascript:void(0);" @click="pergExcluir(item)">
                      <i class="flaticon-delete fs-5 text-danger"></i>
                    </a>
                  </span>

                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4">
          {{ controle.itens.length }} Registros
        </div>
        <div class="col-md-6">
          <Paginador class="float-end" :paginaAtual="controle.filtros.paginaAtual ?? 1"
            :tamanhoPagina="controle.filtros.tamanhoPagina ?? undefined" :total-registros="controle.totalRegistros"
            @onChange="(el) => {
              controle.filtros.paginaAtual = el.paginaAtual;
              controle.filtros.tamanhoPagina = el.tamanhoPagina;
              pesquisar()
            }" />
        </div>
        <div class="col-md-2">
          <RouterLink class="btn btn-secondary btn-sm float-end" :to="'/'">Fechar</RouterLink>
        </div>
      </div>
    </div>
  </div>

  <MsgBox :id="'janExcluir'" :titulo="'Atenção'" :exibir="controle.janExcluir" @onFechou="controle.janExcluir = false"
    :botao-sim="true" :botao-nao="true" @onSim="excluir()">
    <div class="row">
      <div class="col-md-12 fw-bold fs-6">
        Deseja excluir este registro?
      </div>
    </div>
  </MsgBox>

  <MsgBox :id="'janExtender'" :titulo="'Extender Contrato ' + (controle.itemExtender?.contratoId ?? '')"
    :exibir="controle.janExtender" @onFechou="controle.janExtender = false" :botao-gravar="true" :botao-fechar="true"
    @onGravar="confirmarExtender()">
    <div class="row mb-2">
      <div class="col-md-3">
        Data Inicial
      </div>
      <div class="col-md-9">
        <input type="date" class="form-control form-control-sm" v-model="controle.formExtender.dataInicial" />
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-3">
        Meses a Extender
      </div>
      <div class="col-md-9">
        <input type="number" min="1" class="form-control form-control-sm" v-model.number="controle.formExtender.mesesExtender" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-center">
        <span class="">{{ controle.statusExtender }}</span>
        <span class="text-danger fw-bold">{{ controle.erroExtender }}</span>
      </div>
    </div>
  </MsgBox>
</template>

<style lang="css" scoped>
.form-control {
  background: #F5F4FA;
}

.th-sortable {
  cursor: pointer;
  user-select: none;
}

a {
  text-decoration: none;
}

/* Evita quebra de linha nas colunas de nome/telefone apenas no celular */
@media (max-width: 767.98px) {
  .nowrap-celular {
    white-space: nowrap;
  }
}
</style>